(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gb-tile-preview-core"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialized = new WeakSet();

    function bindTilt(component) {
      const previewStage = component.querySelector('.gb-brick-tile-preview-stage');
      const tileTiltRoot = component.querySelector('[data-tilt-root]');
      const tileTilt = component.querySelector('[data-tilt-visual]');

      if (!previewStage || !tileTiltRoot || !tileTilt || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      const maxRotateX = 26;
      const maxRotateY = 36;
      let bounds = null;
      let rafId = 0;
      let pendingTransform = 'rotateX(0deg) rotateY(0deg)';

      function updateBounds() {
        bounds = tileTiltRoot.getBoundingClientRect();
      }

      function scheduleTransform(transform) {
        pendingTransform = transform;

        if (rafId) {
          return;
        }

        rafId = window.requestAnimationFrame(() => {
          tileTilt.style.transform = pendingTransform;
          rafId = 0;
        });
      }

      tileTiltRoot.addEventListener('pointerenter', () => {
        updateBounds();
        tileTilt.style.transition = 'none';
      });

      window.addEventListener('resize', updateBounds);

      tileTiltRoot.addEventListener('pointermove', (event) => {
        if (!bounds) {
          updateBounds();
        }

        const centerX = bounds.left + bounds.width / 2;
        const centerY = bounds.top + bounds.height / 2;
        const radius = Math.min(bounds.width, bounds.height) / 2;
        let deltaX = (event.clientX - centerX) / radius;
        let deltaY = (event.clientY - centerY) / radius;
        const distance = Math.hypot(deltaX, deltaY);

        if (distance > 1) {
          deltaX /= distance;
          deltaY /= distance;
        }

        const rotateY = deltaX * maxRotateY;
        const rotateX = -deltaY * maxRotateX;

        scheduleTransform(`rotateX(${rotateX.toFixed(2)}deg) rotateY(${rotateY.toFixed(2)}deg)`);
      });

      tileTiltRoot.addEventListener('pointerleave', () => {
        bounds = null;
      });

      previewStage.addEventListener('pointerleave', () => {
        if (rafId) {
          window.cancelAnimationFrame(rafId);
          rafId = 0;
        }

        bounds = null;
      });
    }

    function normalizeText(value) {
      return String(value || '').replace(/\s+/g, ' ').trim();
    }

    function normalizeKey(value) {
      return normalizeText(value).toLowerCase();
    }

    function createLooseKey(value) {
      return normalizeKey(value)
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function getElementTextValue(element) {
      if (!(element instanceof Element)) {
        return '';
      }

      const textParts = [...element.childNodes]
        .filter((node) => node.nodeType === Node.TEXT_NODE)
        .map((node) => normalizeText(node.textContent || ''))
        .filter(Boolean)
        .filter((part, index, parts) => part !== parts[index - 1]);

      if (textParts.length) {
        return normalizeText(textParts.join(' '));
      }

      return normalizeText(element.textContent || '');
    }

    function patternValuesMatch(selectedValue, candidateValue) {
      const selectedKey = normalizeKey(selectedValue);
      const candidateKey = normalizeKey(candidateValue);

      if (!selectedKey || !candidateKey) {
        return false;
      }

      if (selectedKey === candidateKey) {
        return true;
      }

      return createLooseKey(selectedKey) === createLooseKey(candidateKey);
    }

    function getPatternPickerLabel(component) {
      return normalizeKey(component.dataset.pickerLabel || '');
    }

    function getCandidateContainers(element) {
      const containers = [];
      let currentElement = element;

      for (let depth = 0; depth < 4 && currentElement; depth += 1) {
        containers.push(currentElement);
        currentElement = currentElement.parentElement;
      }

      return containers;
    }

    function collectCandidateLabelKeys(element) {
      const labelKeys = new Set();
      const labelSelectors = [
        'label',
        'legend',
        '[aria-label]',
        '[data-label]',
        '[data-option-label]',
        '[data-option-name]',
        '[class*="label"]',
        '[class*="title"]',
        '[class*="name"]'
      ];

      function appendText(value) {
        const normalizedValue = normalizeKey(value);

        if (normalizedValue) {
          labelKeys.add(normalizedValue);
        }
      }

      getCandidateContainers(element).forEach((container) => {
        if (!(container instanceof Element)) {
          return;
        }

        container.querySelectorAll(labelSelectors.join(', ')).forEach((node) => {
          if (!(node instanceof Element) || node === element || node.contains(element) || element.contains(node)) {
            return;
          }

          appendText(node.textContent || '');
          appendText(node.getAttribute('aria-label'));
          appendText(node.getAttribute('data-label'));
          appendText(node.getAttribute('data-option-label'));
          appendText(node.getAttribute('data-option-name'));
        });

        appendText(container.previousElementSibling?.textContent || '');
        appendText(container.parentElement?.previousElementSibling?.textContent || '');
      });

      return labelKeys;
    }

    function getSelectedPatternElement(component) {
      const selectedOptions = [...document.querySelectorAll('.po-dropdown-selected-option')];

      if (!selectedOptions.length) {
        return null;
      }

      if (selectedOptions.length === 1) {
        return selectedOptions[0];
      }

      const pickerLabel = getPatternPickerLabel(component);

      if (!pickerLabel) {
        return selectedOptions[0];
      }

      let bestOption = null;
      let bestScore = 0;

      selectedOptions.forEach((option) => {
        const labelKeys = collectCandidateLabelKeys(option);
        let optionScore = 0;

        labelKeys.forEach((labelKey) => {
          if (labelKey === pickerLabel) {
            optionScore = Math.max(optionScore, 3);
            return;
          }

          if (labelKey.includes(pickerLabel) || pickerLabel.includes(labelKey)) {
            optionScore = Math.max(optionScore, 2);
          }
        });

        if (!optionScore) {
          const optionText = normalizeKey(option.textContent || '');
          let containerText = normalizeKey(option.parentElement?.textContent || '');

          if (optionText) {
            containerText = containerText.replace(optionText, '').trim();
          }

          if (containerText.includes(pickerLabel)) {
            optionScore = 1;
          }
        }

        if (optionScore > bestScore) {
          bestScore = optionScore;
          bestOption = option;
        }
      });

      return bestOption || selectedOptions[0];
    }

    function getSelectedPatternText(component) {
      const selectedOption = getSelectedPatternElement(component);

      if (!selectedOption) {
        return '';
      }

      return getElementTextValue(selectedOption);
    }

    function findMatchingPatternOption(component, selectedText) {
      if (!normalizeKey(selectedText)) {
        return null;
      }

      return [...component.querySelectorAll('[data-pattern-option]')].find((option) => {
        const patternName = option.dataset.patternName || option.textContent || '';
        const patternId = option.dataset.patternId || '';

        return patternValuesMatch(selectedText, patternName) || patternValuesMatch(selectedText, patternId);
      }) || null;
    }

    function refreshTileImage(component, selectedText) {
      const patternOption = findMatchingPatternOption(component, selectedText);
      const tileArt = component.querySelector('[data-tile-art]');

      if (!(tileArt instanceof HTMLImageElement) || !patternOption) {
        return;
      }

      const previewUrl = patternOption.dataset.previewUrl || '';
      const previewAlt = patternOption.dataset.previewAlt || selectedText;

      if (previewUrl) {
        tileArt.src = previewUrl;
        tileArt.alt = previewAlt;
      } else {
        tileArt.removeAttribute('src');
        tileArt.alt = '';
      }
    }

    function watchSelectedPatternText(component) {
      let previousText = '';
      let selectedOption = null;
      let optionObserver = null;
      let syncQueued = false;

      function syncPreview() {
        const nextSelectedOption = getSelectedPatternElement(component);

        if (nextSelectedOption !== selectedOption) {
          optionObserver?.disconnect();
          selectedOption = nextSelectedOption;
          optionObserver = null;

          if (selectedOption) {
            optionObserver = new MutationObserver(queueSync);
            optionObserver.observe(selectedOption, {
              childList: true,
              characterData: true,
              subtree: true
            });
          }
        }

        const nextText = getElementTextValue(selectedOption);

        if (nextText === previousText) {
          return;
        }

        previousText = nextText;
        refreshTileImage(component, nextText);
      }

      function queueSync() {
        if (syncQueued) {
          return;
        }

        syncQueued = true;

        window.requestAnimationFrame(() => {
          syncQueued = false;
          syncPreview();
        });
      }

      syncPreview();

      const observer = new MutationObserver(queueSync);

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    function initComponent(component) {
      if (initialized.has(component)) {
        return;
      }

      initialized.add(component);
      moveIntoMediaPrefix(component);
      bindTilt(component);
      watchSelectedPatternText(component);
    }

    function moveIntoMediaPrefix(component) {
      const productInformation = component.closest('.product-information');

      if (!productInformation) {
        return;
      }

      if (component.closest('.product-details') || component.closest('.product-information__media')) {
        return;
      }

      const mediaPrefix = productInformation.querySelector('[data-product-information-media-prefix]');

      if (!mediaPrefix || mediaPrefix.contains(component)) {
        return;
      }

      mediaPrefix.append(component);
    }

    function initAll() {
      document.querySelectorAll('[data-gb-tile-preview]').forEach(initComponent);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
